import styled from "@emotion/styled";

export const HostContainer = styled.div`
  text-align: center;
  margin: 0 0 20px 0;
`;
